
import * as React from 'react';

export class CustomSorter extends React.Component<{}, {}> {
 
    static cleanAndToggleSortOrder( columnData: any , dataindex: any) {
        columnData.forEach(element => {
        if ( element.dataIndex !== dataindex ) {
            element.sortOrder = undefined;
        } else {
            if ( element.sortOrder === 'descend') {
            element.sortOrder = 'ascend';      
            } else {
            element.sortOrder = 'descend';
            }
        }
        });
        return columnData;
    }
}


// WEBPACK FOOTER //
// ./src/components/Sorter.tsx